import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '../ThemeProvider';
import { THEMES } from '../themes';

const ThemePicker = () => {
  const { themeName, setThemeName, themeNames } = useTheme();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('touchstart', onDocClick);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('touchstart', onDocClick);
    };
  }, [open]);

  return (
    <div ref={wrapRef} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Theme picker"
        style={{
          width: 36, height: 36, borderRadius: 10,
          background: 'var(--c-cream)',
          border: 'var(--border-ink-sm)',
          boxShadow: 'var(--shadow-hard-sm)',
          display: 'grid', placeItems: 'center',
          cursor: 'pointer', padding: 0,
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1"
                stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
        </svg>
      </button>

      {open && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 8px)',
          right: 0,
          zIndex: 1000,
          background: 'var(--c-cream)',
          border: 'var(--border-ink)',
          borderRadius: 14,
          boxShadow: 'var(--shadow-hard)',
          padding: 10,
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 8,
          minWidth: 180,
        }}>
          {themeNames.map((name) => {
            const t = THEMES[name];
            const active = name === themeName;
            return (
              <button
                key={name}
                onClick={() => { setThemeName(name); setOpen(false); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  padding: '6px 8px',
                  background: active ? t.ink : t.cream,
                  color: active ? t.cream : t.ink,
                  border: `2px solid ${t.ink}`,
                  borderRadius: 10,
                  cursor: 'pointer',
                  boxShadow: active ? 'none' : `2px 2px 0 ${t.ink}`,
                  transform: active ? 'translate(2px, 2px)' : 'none',
                  fontFamily: 'var(--font-display)',
                  fontSize: 10,
                  letterSpacing: 0.6,
                  textAlign: 'left',
                }}
              >
                <span style={{
                  width: 18, height: 18, borderRadius: 4,
                  background: `linear-gradient(135deg, ${t.pink} 0 50%, ${t.yellow} 50% 100%)`,
                  border: `1.5px solid ${t.ink}`,
                  flexShrink: 0,
                }} />
                {name.toUpperCase()}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ThemePicker;
